jQuery(document).ready(function($) {

    const proto = Accessibility.prototype

    function Accessibility() {
        this._create()
        this._cachedElement
    }

    proto._create = function() {
        this._setupKeybindings()
        this._ariaLabels()
    }   

    proto._ariaLabels = function() {
        $('li.menu-item-has-children').each(function(i, element) {
            $(element).attr('aria-haspopup', true)
            $(element).attr('aria-expanded', false)
        })
    }

    proto._setupKeybindings = function() {
        $(window).on('keydown', (e) => {
            if(this._determineAction(e)) {
                this._openDropdown()
                return false
            }
        })
    }

    proto._determineAction = function(event) {

        if(this._isSpaceReturn(event)) {
            return this._isFocusedDropdown()
        } else if(this._isEscape(event)) {
            this._closeElements()
        }

    }

    proto._isFocusedDropdown = function() {
      
        if($(document.activeElement).parent().hasClass('menu-item-has-children') == true) {
            return true
        } else if($(document.activeElement).hasClass('menu-item-has-children') == true) {
            return true
        }
    }

    proto._isSpaceReturn = function(event) {
        return (event.keyCode == 13 || event.keyCode == 32) ? true : false
    }

    proto._isEscape = function(event) {
        return (event.keyCode == 27) ? true : false
    }

    proto._openDropdown = function() {

        if($(document.activeElement).parent().hasClass('active')) {
            window.location.replace($(document.activeElement).attr('href'))
        } 

        $(document.activeElement).closest('.menu-item-has-children').siblings('li').removeClass('active')
        $(document.activeElement).closest('.menu-item-has-children').addClass('active')
        $(document.activeElement).closest('.menu-item-has-children').attr('aria-expanded', true)
    }

    proto._closeElements = function() {

        if($('.hamburger').hasClass('menu-open')) {
            $('.hamburger').removeClass('menu-open')
            $('#wrapper').removeClass('menu-open')
            $('html, body').removeClass('modal-active menu-active')
            $('.hamburger').attr('aria-pressed', false).focus()
        }

        $('li.menu-item-has-children').each(function(index, li) {
            $(li).removeClass('active')
            $(li).attr('aria-expanded', false)
        })

    }

    new Accessibility()

})


// WEBPACK FOOTER //
// ./assets/js/accessibility.js